// ** Vertical Menu Components
import VerticalNavMenuLink from './VerticalNavMenuLink'
import VerticalNavMenuGroup from './VerticalNavMenuGroup'
import VerticalNavMenuSectionHeader from './VerticalNavMenuSectionHeader'

// ** Utils
import {
  canViewMenuItem,
  canViewMenuGroup,
  resolveVerticalNavMenuItemComponent as resolveNavItemComponent
} from '@layouts/utils'

import { usePage } from '@inertiajs/inertia-react'


const VerticalMenuNavItems = props => {
  // ** Components Object
  const Components = {
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
    VerticalNavMenuSectionHeader
  }
  const {activeItem} = props;
  const { url } = usePage();

  // ** Render Nav Menu Items
  const RenderNavItems = props.items.map((item, index) => {
    const TagName = Components[resolveNavItemComponent(item)]
    if (item.children) {
      return !canViewMenuGroup(item) && <TagName item={item} index={index} key={item.id} {...props} activeItem={url} />
    }
    return !canViewMenuItem(item) && <TagName key={item.id || item.header} item={item} {...props} activeItem={url} />
  })

  return RenderNavItems
}

export default VerticalMenuNavItems
